/**
 * Placeholder rendered when an editor section is not selected or has no data.
 * Use this instead of ad-hoc `<div />` / `<div></div>` for consistency and to allow
 * shared a11y or styling later (e.g. aria-hidden or a shared class).
 */
export const EditorSectionPlaceholder = () => <div />;
